// @core/api/endpoints/document/list_clauses.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListClausesResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List clauses
 * Returns clauses in the product's clause library, filterable by category, jurisdiction, language, tags, and full-text search.
 */
export async function ListClauses(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListClausesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/clauses`;
  const requestOptions = options;
  return client.get<ListClausesResponse>(requestPath, { ...requestOptions, params });
}
